export const profileEn = {
    firstname: {
        name: 'Firstname',
        placeholder: 'Firstname',
        required: 'Please enter firstname',
        too_short: '',
        invalid: '',
    },
    lastname: {
        name: 'Lastname',
        placeholder: 'Lastname',
        required: 'Please enter lastname',
        too_short: '',
        invalid: '',
    },
    contactnumber: {
        name: 'Contact number',
        placeholder: 'Contact number',
        required: 'Contact number',
        too_short: 'Contact number must be {0} digits',
        invalid: 'Incorrect contact number format',
    },
    email: {
        name: 'Email',
        placeholder: 'Email',
        required: 'Please enter email address',
        too_short: '',
        invalid: 'Incorrect email format',
    },
    idCard: {
        name: 'ID card',
        placeholder: 'ID card',
        required: 'Pleae enter ID card',
        too_short: '',
        invalid: '',
    },
    password: {
        name: 'Password',
        placeholder: 'Password',
        required: 'Please enter passwrod',
        too_short: '',
        invalid: '',
    },
    gender: {
        name: 'Gender',
        placeholder: '',
        required: 'Please select gender',
        too_short: '',
        invalid: '',
        defaultText: 'Please select',
    },
    birthdate: {
        name: 'Birthdate',
        placeholder: '',
        required: 'Please select birthdate',
        too_short: '',
        invalid: 'Birthdate invalid',
        date: {
            name: '',
            defaultText: 'Day',
            required: ''
        },
        month: {
            name: '',
            defaultText: 'Month',
            required: ''
        },
        year: {
            name: '',
            defaultText: 'Year',
            required: ''
        },
    },
}
